import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";

const initialFValues = {
  locationName: "",
  costPrice: 0,
  salesPrice: 0,
  quantity: "",
  productName: "",
  remark: "",
};

export default function InventoryForm(props) {
  const { addOrEdit, recordForEdit, products, locations } = props;
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("salesPrice" in fieldValues) temp.salesPrice = fieldValues.salesPrice;
    if ("quantity" in fieldValues) temp.quantity = fieldValues.quantity;
    if ("costPrice" in fieldValues) temp.costPrice = fieldValues.costPrice;
    temp.sku = fieldValues.sku;
    if ("locationId" in fieldValues) temp.locationId = fieldValues.locationId;
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      addOrEdit(values, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          {/* <Controls.Input
                        name="salesPrice"
                        label="Sales Price"
                        readOnly={true}
                        disabled = {true}
                        value={values.salesPrice || ''}
                        onChange={handleInputChange}
                        error={errors.salesPrice}
                    /> */}
          <Controls.Input
            name="costPrice"
            label="Cost Price"
            readOnly={true}
            disabled={true}
            value={values.costPrice || ""}
            onChange={handleInputChange}
            error={errors.costPrice}
          />
          <Controls.Input
            label="Quantity"
            name="quantity"
            readOnly={true}
            disabled={true}
            value={values.quantity || ""}
            onChange={handleInputChange}
            error={errors.quantity}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            label="Product"
            name="productName"
            readOnly={true}
            disabled={true}
            value={values.productName || ""}
            onChange={handleInputChange}
            error={errors.productName}
          />
          <Controls.Input
            label="Remark"
            name="remark"
            readOnly={true}
            disabled={true}
            value={values.remark || ""}
            onChange={handleInputChange}
            error={errors.remark}
          />
          <Controls.Input
            label="Select Storage (Location)"
            name="storageName"
            readOnly={true}
            disabled={true}
            value={values.locationName || ""}
            onChange={handleInputChange}
            error={errors.locationName}
          />
        </Grid>
      </Grid>
    </Form>
  );
}
